<template>
    <div class="row">
      <div class="col s12">
          <div class="input-field col s12">
            <input v-bind:searchTerm="searchTerm" :placeholder="placeholder" v-on:input="$emit('input', $event.target.value)" id="search_box" type="text" dir="auto">
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    name: 'searchBox',
    props: {
    placeholder: String,
    searchTerm: String
  }

  }
</script>